import { Group, Rect, Text } from 'react-konva'
import { getIconCanvasFrame } from '../iconKinds'
import { resolveCanvasSubscriptionGoldColor } from '../canvasClassColor'
import { fitEntityLabelFontSize } from './entityBadgeFont'
import { ResolvedEntityBadge } from './entityAssignmentMatching'
import { IconShape } from './iconShapes'

type Props = {
  shape: IconShape
  width: number
  height: number
  zoomScale?: number
  startNumber?: number
  entityAssignments?: Map<number, ResolvedEntityBadge>
  showText?: boolean
}

const IconEntityBadge = ({
  shape,
  width,
  height,
  zoomScale = 1,
  startNumber = 1,
  entityAssignments,
  showText = true,
}: Props) => {
  const scale = zoomScale > 1 ? zoomScale : 1
  const pixelWidth = shape.width * width
  const pixelHeight = shape.height * height
  const minSide = Math.min(pixelWidth, pixelHeight)
  const frame = getIconCanvasFrame(shape.kind, shape.value)
  const cornerRadius = frame
    ? frame.corner === 'circle'
      ? minSide / 2
      : minSide * 0.25
    : 0
  const fontSize = Math.max(8, Math.round(minSide * 0.475))
  const entityBadge = entityAssignments?.get(startNumber)
  const label = entityBadge ? entityBadge.name : String(startNumber)
  const isOwn = entityBadge?.isOwn ?? false
  const borderColor = isOwn ? resolveCanvasSubscriptionGoldColor() : ''
  const labelColor = entityBadge?.color ?? 'rgba(248, 250, 252, 0.95)'
  const labelWidth = entityBadge ? minSide * 1.4 : minSide
  const labelFontSize = entityBadge
    ? fitEntityLabelFontSize(entityBadge.name, labelWidth, 11 / scale, fontSize)
    : fontSize
  const showBackdrop = shape.kind !== 'role'

  return (
    <>
      <Rect
        width={pixelWidth}
        height={pixelHeight}
        cornerRadius={cornerRadius}
        fill={showBackdrop ? 'rgba(15, 23, 42, 0.35)' : undefined}
        stroke={isOwn ? borderColor : undefined}
        strokeWidth={isOwn ? 3 / scale : 0}
        listening={false}
      />
      <Group
        x={pixelWidth / 2}
        y={pixelHeight / 2}
        rotation={-(shape.rotation ?? 0)}
        listening={false}
        visible={showText}
      >
        <Text
          x={-labelWidth / 2}
          y={-minSide / 2}
          width={labelWidth}
          height={minSide}
          text={label}
          fontSize={labelFontSize}
          fontStyle='bold'
          fill={labelColor}
          align='center'
          verticalAlign='middle'
          wrap='none'
          shadowColor='rgba(0, 0, 0, 0.9)'
          shadowBlur={4}
          shadowOpacity={1}
        />
      </Group>
    </>
  )
}

export default IconEntityBadge
